import { useEffect, useMemo, useRef, useState } from "react";
import { useSearchParams } from "react-router-dom";
import {
  filtersHaveActiveValues,
  parseListStateFromSearch,
  serializeListStateToUrlParams,
} from "utils/listUrlSync";

/**
 * Keeps list state (page, pageSize, sort, filters) in the URL and restores it on navigation.
 * @param {object} urlDefaults stable defaults: { orderBy, orderDirection }
 * @param {{ preserveParentId?: boolean }} options when true, keeps parent_id on document sub-lists
 */
export function useListUrlSync(urlDefaults, options = {}) {
  const { preserveParentId = false } = options;
  const [usp, setUsp] = useSearchParams();
  const [searchParams, setSearchParams] = useState(() =>
    parseListStateFromSearch(usp.toString(), urlDefaults)
  );
  const uspRef = useRef(usp);
  uspRef.current = usp;

  useEffect(() => {
    const next = serializeListStateToUrlParams(searchParams, urlDefaults);
    if (preserveParentId) {
      const pid = uspRef.current.get("parent_id");
      if (pid != null && pid !== "") {
        next.set("parent_id", pid);
      }
    }
    setUsp(next, { replace: true });
  }, [searchParams, setUsp, urlDefaults, preserveParentId]);

  const hasActiveFilters = useMemo(
    () => filtersHaveActiveValues(searchParams.filters),
    [searchParams.filters]
  );

  return { searchParams, setSearchParams, hasActiveFilters, urlSearchParams: usp };
}
